import { render, staticRenderFns } from "./PartnerForm.vue?vue&type=template&id=1413abcc&scoped=true&"
import script from "./PartnerForm.vue?vue&type=script&lang=js&"
export * from "./PartnerForm.vue?vue&type=script&lang=js&"
import style0 from "./PartnerForm.vue?vue&type=style&index=0&id=1413abcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413abcc",
  null
  
)

export default component.exports